import classNames from 'classnames';
import React from 'react';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import PostTitleWithIcons from '../post/PostTitleWithIcons';
import Link from '../utils/router/Link';
import postPath, { publicPostPath } from '../utils/url/postPath';
import useIsPublicView from '../utils/useIsPublicView';
import * as styles from './SeriesRow.module.scss';

const POST_FRAGMENT = gql(`
  fragment SeriesRow_post on RootPostFields {
    ...postPath_post
    ...PostTitleWithIcons_post
  }
`);

interface SeriesRowProps {
  active?: boolean;
  index: number;
  post: DocumentType<typeof POST_FRAGMENT>;
  noLink?: boolean;
  noPadding?: boolean;
}

const SeriesRow = ({
  active = false,
  index,
  post,
  noLink = false,
  noPadding = false,
}: SeriesRowProps) => {
  const isPublicView = useIsPublicView();

  const commonProps = {
    className: classNames(styles.row, {
      [styles.active]: active,
      [styles.noLink]: noLink,
      [styles.noPadding]: noPadding,
    }),
  };
  const children = (
    <>
      <span className={styles.number}>{index + 1}</span>
      <span className={styles.title}>
        <PostTitleWithIcons post={post} iconSize="small" />
      </span>
    </>
  );

  return noLink ? (
    <div {...commonProps}>{children}</div>
  ) : (
    <Link
      to={isPublicView ? publicPostPath(post) : postPath(post)}
      {...commonProps}
    >
      {children}
    </Link>
  );
};

export default SeriesRow;
